export var ORDERED_DAYS = [
    { key: 'monday', labelKey: 'days.monday', initialKey: 'days.mondayInitial' },
    { key: 'tuesday', labelKey: 'days.tuesday', initialKey: 'days.tuesdayInitial' },
    { key: 'wednesday', labelKey: 'days.wednesday', initialKey: 'days.wednesdayInitial' },
    { key: 'thursday', labelKey: 'days.thursday', initialKey: 'days.thursdayInitial' },
    { key: 'friday', labelKey: 'days.friday', initialKey: 'days.fridayInitial' },
    { key: 'saturday', labelKey: 'days.saturday', initialKey: 'days.saturdayInitial' },
    { key: 'sunday', labelKey: 'days.sunday', initialKey: 'days.sundayInitial' },
];
export var DEFAULT_DAYS = ORDERED_DAYS.map(function (d) { return ({
    dayOfWeek: d.key,
    isAvailable: false,
    startTime: null,
    endTime: null,
}); });
